const actions = {
  GET_BITAQATY_BALANCE_BEGIN: 'GET_BITAQATY_BALANCE_BEGIN',
  GET_BITAQATY_BALANCE_SUCCESS: 'GET_BITAQATY_BALANCE_SUCCESS',
  GET_BITAQATY_BALANCE_ERR: 'GET_BITAQATY_BALANCE_ERR',

  GET_BITAQATY_MERCHANTS_BEGIN: 'GET_BITAQATY_MERCHANTS_BEGIN',
  GET_BITAQATY_MERCHANTS_SUCCESS: 'GET_BITAQATY_MERCHANTS_SUCCESS',
  GET_BITAQATY_MERCHANTS_ERR: 'GET_BITAQATY_MERCHANTS_ERR',

  GET_BITAQATY_PRODUCTS_BEGIN: 'GET_BITAQATY_PRODUCTS_BEGIN',
  GET_BITAQATY_PRODUCTS_SUCCESS: 'GET_BITAQATY_PRODUCTS_SUCCESS',
  GET_BITAQATY_PRODUCTS_ERR: 'GET_BITAQATY_PRODUCTS_ERR',

  getBitaqatyBalanceBegin: () => {
    return {
      type: actions.GET_BITAQATY_BALANCE_BEGIN,
    };
  },

  getBitaqatyBalanceSuccess: (data) => {
    return {
      type: actions.GET_BITAQATY_BALANCE_SUCCESS,
      data,
    };
  },

  getBitaqatyBalanceErr: (err) => {
    return {
      type: actions.GET_BITAQATY_BALANCE_ERR,
      err,
    };
  },

  getBitaqatyMerchantsBegin: () => {
    return {
      type: actions.GET_BITAQATY_MERCHANTS_BEGIN,
    };
  },

  getBitaqatyMerchantsSuccess: (data) => {
    return {
      type: actions.GET_BITAQATY_MERCHANTS_SUCCESS,
      data,
    };
  },

  getBitaqatyMerchantsErr: (err) => {
    return {
      type: actions.GET_BITAQATY_MERCHANTS_ERR,
      err,
    };
  },

  getBitaqatyProductsBegin: () => {
    return {
      type: actions.GET_BITAQATY_PRODUCTS_BEGIN,
    };
  },

  getBitaqatyProductsSuccess: (data) => {
    return {
      type: actions.GET_BITAQATY_PRODUCTS_SUCCESS,
      data,
    };
  },

  getBitaqatyProductsErr: (err) => {
    return {
      type: actions.GET_BITAQATY_PRODUCTS_ERR,
      err,
    };
  },
};

export default actions;
